import React  from 'react';
import './App.css';
import MyInfoLang from './MyInfoLang.json';
  
import { useNavigate } from "react-router-dom";

class MyInfoName extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			firstName: "",
			lastName: "",
		};

		this.onKeyDown = this.onKeyDown.bind(this);
		this.onFirstNameChanged = this.onFirstNameChanged.bind(this);		
		this.onLastNameChanged = this.onLastNameChanged.bind(this);		
		this.serverUpdateName = this.serverUpdateName.bind(this);
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}
	
	componentDidMount(){
		this.setState({
			firstName: this.props.firstName,
			lastName: this.props.lastName,
		});
	}

	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	onFirstNameChanged(value) {
		this.setState({firstName: value});
	}
	
	onLastNameChanged(value) {
		this.setState({lastName: value});
	}
	
	async serverUpdateName(userID, firstName, lastName) {

		var managementBaseURLAPI = this.props.managementBaseURLAPI;
		var url = managementBaseURLAPI + "/updateusername?userid=" + userID;
		url = url + "&firstname=" + encodeURI(firstName);
		url = url + "&lastname=" + encodeURI(lastName);

		const res = await fetch(url);
		await res.text();
	}
		
	onClickSaveButton() {
		this.serverUpdateName(this.props.userID, this.state.firstName, this.state.lastName);
		this.props.serverGetUserData(this.props.userID);
		const navigate = this.props.navigate;
  		navigate("/myaccount");
	}
	
	onClickCancelButton() {
		const navigate = this.props.navigate;
  		navigate("/myaccount");
	}
	
	render() {

		var saveButtonYN = true;
		var firstName = this.props.firstName;
		var lastName = this.props.lastName;

		return (
			<div className="ViewContainer">
			
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">{this.props.getLang(MyInfoLang, "updateYourName")}</div>
				<div className="ViewTopText">{this.props.getLang(MyInfoLang, "updateYourNameMessage")}</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">Name</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewItemContainer">
						<div style={{height: "20px"}}></div>
						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(MyInfoLang, "firstName")}</legend> 
							<input
								className="ViewItemInput" 
								id="firstName" 
								type="text" 
								autoFocus={true}
								defaultValue={firstName}
								onChange={(event) => this.onFirstNameChanged(event.target.value)}
								onKeyDown={(event) => this.onKeyDown(event.keyCode)}
							/>
						</fieldset>
						<div style={{height: "20px"}}></div>
						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(MyInfoLang, "lastName")}</legend> 
							<input
								className="ViewItemInput" 
								id="lastName" 
								type="text" 
								defaultValue={lastName}
								onChange={(event) => this.onLastNameChanged(event.target.value)}
								onKeyDown={(event) => this.onKeyDown(event.keyCode)}
							/>
						</fieldset>
					</div>
					<div style={{height: "60px"}}></div>
					<div className="ViewContainerButtons">
						<div style={{width: "200px"}}></div>
						<button className="ViewCancelButton" onClick={this.onClickCancelButton}>{this.props.getLang(MyInfoLang, "cancelButton")}</button>
						<div style={{width: "20px"}}></div>
						<button className="ViewSaveButton" onClick={this.onClickSaveButton} disabled={!saveButtonYN}>{this.props.getLang(MyInfoLang, "saveButton")}</button>
					</div>
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function MyInfoNameFunction(props) {
	const navigate = useNavigate();
	return <MyInfoName {...props} navigate={navigate} />;
}


